<template>
    <div class="DshAdvSearchForm">
        <!-- 筛选逻辑 -->
        <div class="DshAdvSearchForm-title">筛选逻辑</div>
        <dsh-select
            style="margin: 10px 0px 12px;"
            :canEdit="canEdit"
            :value="value"
            :propsObj="logicPropsObj"
            @change="change"
        ></dsh-select>

        <!-- 筛选条件 -->
        <div class="DshAdvSearchForm-title">筛选条件</div>
        <div class="DshAdvSearchForm-controls">
            <dsh-formItem
                v-for="(conditionItem, conditionIndex) in value.conditions"
                :key="conditionItem._id"
                :class="['DshAdvSearchForm-controls-item']"
                :canEdit="canEdit"
                :formData="conditionItem"
                :formItem="conditionItem.formItem"
                height="80"
                @change="change(conditionItem, arguments)"
            >
                <!-- 单条关联层层筛选 -->
                <z-sub-search
                    v-if="conditionItem.fieldOperator==='subSearch'"
                    :mode="mode"
                    :canEdit="canEdit"
                    :value="conditionItem"
                    :propsObj="conditionItem.formItem"
                    :fieldTypeMap="fieldTypeMap"
                    @change="change(conditionItem, arguments)"
                ></z-sub-search>

                <!-- 动态参数选择 -->
                <dsh-select
                    v-if="fieldTypeMap[conditionItem.fieldType] && fieldTypeMap[conditionItem.fieldType].length && (conditionItem.parameterType === 'dynamicText')"
                    class="dsh-margin-bottom5"
                    :canEdit="canEdit"
                    :value="conditionItem"
                    :propsObj="{
                        _name: `${conditionItem.formItem._name}的动态参数`,
                        _key: 'fieldParams',
                        _multiple: true,
                        _data: fieldTypeMap[conditionItem.fieldType]
                    }"
                    @change="change(conditionItem, arguments)"
                ></dsh-select>

                <!-- operator筛选类型 -->
                <div
                    slot="extra"
                    class="DshAdvSearchForm-controls-extra"
                >
                    <!-- 筛选参数类型 -->
                    <dsh-select
                        v-if="fieldTypeMap[conditionItem.fieldType] && fieldTypeMap[conditionItem.fieldType].length"
                        class="DshAdvSearchForm-controls-item-select"
                        :value="conditionItem"
                        :propsObj="parameterPropsObj"
                    ></dsh-select>

                    <dsh-dropdown
                        class="dsh-margin-right10"
                        :list="conditionItem.operators"
                        @click="$dispatchEvent(operationMap.selectOperator, $event, conditionItem)"
                    >
                        <span class="DshAdvSearchForm-controls-item-operator">
                            <span class="DshAdvSearchForm-controls-item-operator-name">{{ conditionItem.fieldOperatorName }}</span>
                            <Icon
                                class="dsh-margin-left5"
                                type="ios-arrow-down"
                            />
                        </span>
                    </dsh-dropdown>
                </div>

                <!-- 删除 -->
                <dsh-icons
                    slot="corner"
                    class="DshAdvSearchForm-controls-delete"
                    :list="$getOperationList(['deleteContion'])"
                    @click="$dispatchEvent(operationMap.deleteContion, conditionItem, conditionIndex, value.conditions)"
                />
            </dsh-formItem>
        </div>

        <!-- 添加 -->
        <dsh-dropdown
            class="DshAdvSearchForm-controls-create"
            menuClass="DshAdvSearchForm-controls-create-list"
            :list="searchFormList"
            @click="$dispatchEvent(operationMap.createContion, $event)"
        >
            <dsh-buttons
                :list="$getOperationList(['createContion'])"
                itemClass="DshAdvSearchForm-controls-create-btn"
            ></dsh-buttons>
        </dsh-dropdown>
    </div>
</template>

<script>
    import searchMixin from "./searchMixin.js";
    import ZSubSearch from "./ZSubSearch.vue";

    export default {
        name: "DshAdvSearchForm",
        mixins: [searchMixin],
        components: {
            ZSubSearch
        },
        props: {
            canEdit: {
                type: Boolean,
                default: true
            },

            value: {
                type: Object,
                default () {
                    return {
                        logic: "and",
                        conditions: []
                    };
                }
            },
            formList: {
                type: Array,
                default () {
                    return [];
                }
            },
            initSearchFields: {
                type: Array,
                default () {
                    return [];
                }
            },
            initData: {
                type: Object,
                default () {
                    return {};
                }
            },
            fieldTypeMap: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {
            };
        },
        computed: {
            searchFormList () {
                return this.formList.filter(formItem => this.fieldMap[formItem._type].canSearch);
            }
        },
        created () {
            this.init();
        },
        methods: {
            // 初始化
            init () {
                if (this.initSearchFields.length !== 0) {
                    this.value.conditions = this.initSearchFields.map(fieldKey => {
                        let formItem = this.formList.find(formItem => formItem._key === fieldKey);
                        return this.$createContion(formItem);
                    });
                }
                Object.assign(this.value, this.initData);

                this.value.conditions = this.value.conditions.map(conditionItem => {
                    const fieldData = this.fieldMap[conditionItem.fieldType];
                    const operators = fieldData[this.mode === "set" ? "operatorsSet" : "operators"] || fieldData.operators;
                    return {
                        ...conditionItem,
                        fieldOperatorName: operators.find(operatorItem => operatorItem._key === conditionItem.fieldOperator).name,
                        operators: operators,
                        formItem: this.getFormItem(conditionItem.fieldKey),
                        parameterType: (conditionItem.fieldParams && conditionItem.fieldParams.length) ? "dynamicText" : "fixedText"
                    };
                });
            }

        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/form/DshAdvSearchForm.vue